import React, {useState} from 'react';
import {
    Container,
    Grid,
    Button,
    Paper,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import TextField from "@material-ui/core/TextField";
import {
    Box, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    TablePagination, Typography
} from "@mui/material";
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from "@material-ui/icons/Search";
import {PBDQ3_PROGRAM_STATE_VERBOSE} from "../../utils/constants";

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(4),
    },
    addButton: {
        marginBottom: theme.spacing(2),
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        color: '#fff',
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        },
    },
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '45px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: '32px !important',
        },
    },
    tableRoot: {
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: '0px',
    },
    tableHeaderCell: {
        fontSize: '17px',
        fontWeight: 500,
    },
    tableCell: {
        color: '#EE6628',
    },
    actionButton: {
        borderRadius: '20px',
        fontSize: '13px',
        padding: '6px 12px',
        marginRight: theme.spacing(1),
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        color: '#fff',
        minWidth: '100px',
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        }, [theme.breakpoints.down('sm')]: {
             marginBottom:'15px',
            width:'35px',
            borderRadius: '13px',

        },
    },
    searchContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    searchInput: {
        marginLeft: theme.spacing(1),
        width: '300px',
    },

}));

const ProgramsList = ({ data, actions, options }) => {
    const classes = useStyles();
    const { programs } = data;
    const { createProgramAction, removeProgramAction, viewProgramAction } = actions;

    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [programToDelete, setProgramToDelete] = useState(null);

    const [searchText, setSearchText] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleCreateProgram = () => {
        if (createProgramAction) {
            createProgramAction();
        }
    };

    const handleViewProgram = (programId, program_state) => {
        if (viewProgramAction) {
            viewProgramAction(programId, program_state);
        }
    };

    const handleDeleteProgram = (programId) => {
        setProgramToDelete(programId);
        setDeleteDialogOpen(true);
    };

    const handleConfirmDelete = () => {
        if (removeProgramAction && programToDelete) {
            removeProgramAction(programToDelete);
        }
        setDeleteDialogOpen(false);
        setProgramToDelete(null);
    };

    const handleCancelDelete = () => {
        setDeleteDialogOpen(false);
        setProgramToDelete(null);
    };

    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
        setPage(0); // Reset to first page when search changes
    };

    const handleSearchClear = () => {
        setSearchText('');
        setPage(0);
    };

    const escapeRegExp = (value) => {
        return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    };

    const filteredPrograms = programs.filter((program) => {
        const regex = new RegExp(escapeRegExp(searchText), 'i');
        return (
            regex.test(program.program_id) ||
            regex.test(program.title) ||
            regex.test(program.createdAt) ||
            // regex.test(program.package) ||
            regex.test(program.status)
        );
    });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const date_options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

    return (
        <Container className={classes.container} maxWidth={false}>
            <Typography variant="h3" sx={{ textAlign: "center", marginBottom: 2, marginTop:{xs:'55px', sm:'40px'} }} className={classes.title}>
                Your Created Programs
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    fontSize: "1.2rem",
                    textAlign: "center",
                    marginBottom: 4,
                    maxWidth: "100%",
                    color: "#474747",
                }}
            >
                The following is a list of your created programs. Access them below.
            </Typography>
            <Box display={'flex'} alignItems="center"  mb={2} sx={{justifyContent:{sm:"flex-end", xs:'center'}}}>
                <Button
                    startIcon={<AddIcon />}
                    variant="contained"
                    color="primary"
                    className={classes.addButton}
                    onClick={handleCreateProgram}
                >
                    CREATE NEW PROGRAM
                </Button>
                {/*<div className={classes.searchContainer}>*/}
                {/*    <TextField*/}
                {/*        variant="outlined"*/}
                {/*        value={searchText}*/}
                {/*        onChange={handleSearchChange}*/}
                {/*        placeholder="Search…"*/}
                {/*        className={classes.searchInput}*/}
                {/*        InputProps={{*/}
                {/*            startAdornment: <SearchIcon fontSize="small" />,*/}
                {/*            endAdornment: (*/}
                {/*                <IconButton*/}
                {/*                    title="Clear"*/}
                {/*                    aria-label="Clear"*/}
                {/*                    size="small"*/}
                {/*                    style={{ visibility: searchText ? 'visible' : 'hidden' }}*/}
                {/*                    onClick={handleSearchClear}*/}
                {/*                >*/}
                {/*                    <ClearIcon fontSize="small" />*/}
                {/*                </IconButton>*/}
                {/*            ),*/}
                {/*        }}*/}
                {/*    />*/}
                {/*</div>*/}
            </Box>
            <TableContainer component={Paper}>
                <Table className={classes.tableRoot} aria-label="programs table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tableHeaderCell} align="center">Program ID</TableCell>
                            <TableCell className={classes.tableHeaderCell} align="center">Program Title</TableCell>
                            <TableCell className={classes.tableHeaderCell} align="center">Submission Date</TableCell>
                            {/*<TableCell className={classes.tableHeaderCell}>Package</TableCell>*/}
                            <TableCell className={classes.tableHeaderCell} align="center">Status</TableCell>
                            <TableCell className={classes.tableHeaderCell} align="center">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredPrograms.length > 0 ? (
                            filteredPrograms
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((program) => (
                                    <TableRow key={program.program_id}>
                                        <TableCell className={classes.tableCell} align="center">{program.program_id}</TableCell>
                                        <TableCell className={classes.tableCell} align="center">{program.course_name ? program.course_name : ''}</TableCell>
                                        <TableCell className={classes.tableCell} align="center">
                                            {(new Date(program.createdAt)).toLocaleDateString(undefined, date_options)}
                                        </TableCell>
                                        {/*<TableCell className={classes.tableCell}>{program.package}</TableCell>*/}
                                        <TableCell className={classes.tableCell} align="center">
                                            {PBDQ3_PROGRAM_STATE_VERBOSE[program.program_state]}
                                        </TableCell>
                                        <TableCell  className={classes.tableCell} align="center">
                                            <Button
                                                className={classes.actionButton}
                                                variant="contained"
                                                onClick={() => handleViewProgram(program.program_id, program.program_state)}
                                            >
                                                View
                                            </Button>
                                            <Button
                                                className={classes.actionButton}
                                                variant="contained"
                                                color="secondary"
                                                onClick={() => handleDeleteProgram(program.program_id)}
                                            >
                                                Delete
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    No programs found.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredPrograms.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
            <Dialog
                open={deleteDialogOpen}
                onClose={handleCancelDelete}
            >
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this program?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelDelete} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmDelete} color="secondary">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
};

export default ProgramsList;